import { render, staticRenderFns } from "./onsite-processing.vue?vue&type=template&id=475142da&scoped=true"
import script from "./onsite-processing.vue?vue&type=script&lang=js"
export * from "./onsite-processing.vue?vue&type=script&lang=js"
import style0 from "./onsite-processing.vue?vue&type=style&index=0&id=475142da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475142da",
  null
  
)

export default component.exports